import withStyles from '@material-ui/core/styles/withStyles';
import { graphql, Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';

import BrowserLock from '../images/credit-cards/browserLock.svg';
import CardsSittingGuyPlant from '../images/credit-cards/cardsSittingGuyPlant.svg';
import CloudLockGirlLaptop from '../images/credit-cards/cloudLockGirlLaptop.svg';
import EmailContactSales from '../components/EmailContactSales';
import Phone from '../images/credit-cards/phone.svg';
import PlantGirlCard from '../images/credit-cards/plant-girl-card.svg';
import TargetArrowInline from '../images/credit-cards/target-arrow.svg';
import circleGreenCreditCard from '../images/icons/circle-green-credit-card.png';
import creditCardsSplash from '../images/credit-cards/header-gradient.png';
import WantToSeeHow from '../components/WantToSeeHow';

import halfSectionGradient from '../images/credit-cards/half-section-gradient.png';
import halfSectionWithPattern from '../images/credit-cards/half-section-with-pattern.png';

import fullWidthSplitBgWhiteGreen from '../images/credit-cards/fullWidthSplitBgWhiteGreen.png';
import cardOnSide from '../images/credit-cards/cardOnSide.png';

import PhonePlayer from '../components/PhonePlayer';
import PhoneVideoMP4 from '../videos/pcc.mp4';
import PhoneVideoWEBM from '../videos/pcc.webm';
import pccVideoThumbnail from '../images/phone/pcc.jpg';
import Testimonial from '../components/Testimonial';
import blackhawkBankTrust from '../images/credit-cards/blackhawkBankTrust.png';

const styles = { paper: { margin: '1em', }, };

const Section = styled.section`

	&.full-width-split figure {
		background-color: #54a596;
		background-image: ${(props) => `url('${halfSectionWithPattern}')`};

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${halfSectionGradient}')`};
		}

		& .decorationBehindPhone {
			background-image: ${(props) => `url('${cardOnSide}')`};
			background-position: left center;
			padding: 0 11%;
			background-size: 125px 162px;

			@media (${(props) => props.theme.smallUp}) {
				padding: 0 17%;
				background-size: 251px 335px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				padding: 0 0 0 14%;
				background-size: 150px 200px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding: 0 0 0 17%;
				background-size: 251px 335px;
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.whiteLeftGreenRight {
			background-image: ${(props) => `url('${fullWidthSplitBgWhiteGreen}')`};
		}
	}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		background-image: none;

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${circleGreenCreditCard}')`};
			background-repeat: no-repeat;
			background-position: right center;
			width: 330px;
		}

		@media (${(props) => props.theme.largeUp}) {
			width: 410px;
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: 1em;
`;

interface CreditCardsProps {
	classes: Record<string, any>;
	data: any;
}

interface CreditCardsState {
	isDialogOpen: boolean;
}

class CreditCardsPage extends React.Component<CreditCardsProps, CreditCardsState> {
	state = {
		isDialogOpen: false,
	};

	closeDialog = () => {
		this.setState({ isDialogOpen: false });
	}

	watchVideo = () => {
		this.setState({ isDialogOpen: true });
	}

	render () {
		const {
			classes,
			data,
			data: {
				site: {
					siteMetadata: { endpoint },
				},
			},
		} = this.props;

		const creditCardsHeaderContent =
			<HeaderContentArticle>
				<h1>Personal<br />Credit Cards</h1>
				<p>Move past the busy work<br />and issue more credit cards.</p>
				<EmailContactSales />
			</HeaderContentArticle>
		;

		const plantGirlCardFigure =
			<HeaderBottomContentFigure>
				<PlantGirlCard alt='Girl with Credit Card' />
			</HeaderBottomContentFigure>
		;

		return <Layout
			headerBottomContent={plantGirlCardFigure}
			headerContent={creditCardsHeaderContent}
			headerSplashBg={creditCardsSplash}
			headerSplashBgAverageColor={'#54a596'}
			metaDescription={"MK Decision's Credit Card Origination System (CCOS) helps financial institutions issue more credit cards"}
			pageTitle={'Credit card origination system | CCOS'}
			skipMoney2020={true}
			BodyClass={'ccos UseCases'}
		>
			<div className='centeredWrapper'>
				<Section className='centered-text'>
					<h2 style={{maxWidth: `18em`, margin: `0 auto`}}>The leading loan origination system for personal credit cards</h2>
				</Section>
				<Section className='go-mobile row row-flush centered'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='text-box'>
							<header>
								<Phone alt='Smart Phone' />
								<h2>Mobile-first for a<br />modern customer experience</h2>
							</header>
							<p>Supported on over 400 devices, MK’s mobile first lending platform provides frictionless customer experiences. Make it fast and easy for your customers to access the credit they need from any device, with automated approvals and a paperless application process. It’s never been this convenient to apply for a credit card.</p>

						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<CardsSittingGuyPlant alt='Credit cards, man holding phone' />
					</figure>
				</Section>
			</div>
			<Section className='full-width-split full-width whiteLeftGreenRight'>
				<div className='centeredWrapper'>
					<div className='responsivePadding row row-flush'>
						<article className='col-12 col-md-6 left-on-desktop'>
							<div className='text-box'>
								<header>
									<TargetArrowInline alt="Arrow in bull's eye" />
									<h2>Ensure customer loyalty<br />and brand recognition</h2>
								</header>
								<p>MK values the loyalty your customers place in your brand. We maintain this trust by designing card details landing pages that ensure a consistent customer experience with the rest of your web presence. Gone are the days of antiquated account opening solutions that degrade and diminish your brand.</p>
								{/* <p>Our platform is easy to implement and gets your financial products to market fast. Built by lenders, for lenders, MK’s products integrate with credit bureaus and core processors to expedite difficult
		underwriting processes.</p> */}
							</div>
						</article>
						<figure className='col-12 col-md-6 right-on-desktop'>
							<PhonePlayer
								PhoneVideoMP4={PhoneVideoMP4}
								PhoneVideoWEBM={PhoneVideoWEBM}
							/>
						</figure>
					</div>
				</div>
			</Section>
			<div className='centeredWrapper'>
				<Section className='secure-compliant row row-flush centered'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='text-box'>
							<header>
								<BrowserLock alt='Secure browser' />
								<h2>Secure and compliant<br />from cloud to customer</h2>
							</header>
							<p>Hosted on the Amazon Web Services (AWS) <a href='https://mkdecision.com/blog/2019/10/22/touch-the-clouds-with-dashboard/'>Cloud,</a> MK ensures disaster recovery and business continuity by leveraging multi-regional server redundancy. Real-time KYC and instant, secure digital messaging for Adverse Action Letters and Risk-Based Pricing Notices reduce your risk of fraud and ensure regulatory compliance.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<CloudLockGirlLaptop alt='User accessing secure cloud' />
					</figure>
				</Section>
			</div>
			<Testimonial
				name={'Chad Borland'}
				title={'Branch Manager'}
				company={'Blackhawk Bank & Trust'}
				quote={'It is a pleasure working with MK for our online credit card application process. They are efficient and willing to take care of all our needs as a financial institution.'}
				logo={blackhawkBankTrust}
				logoAlt={'Blackhawk Bank logo'}
			/>
			<div className='centeredWrapper'>
				<WantToSeeHow />
			</div>
		</Layout>;
	}
}

export default withStyles(styles)(CreditCardsPage);

export const pageQuery = graphql`
	query {
		site: site {
			siteMetadata {
				endpoint
			}
		}
  	}
`;
